import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import {commonValidateRule} from '@/libs/rules_utils.js'
import { getsafe } from '@/libs/util.js'

import { createEpopAccount } from '@/views/business/utils.js'
import { account_types} from '@/views/fin/account_management/fields.js'
import {getAmsPlatformListApi, getAmsCommonLoginMethodsApi, getPersonApi} from '@/views/business/service.js'
import {getContractDetailApi} from '../service'
const commonValidateRuleGo = commonValidateRule('必选')
const commonValidateRuleT = commonValidateRule('必填')
export default {
    props: {
        value: {
            type: Object
        }
    },
    data() {
        this.source_data = null
        return {
            show: false,
            saving: false,
            params: {
                multi_payee: 1,
            },
            platform_list: [],
            platform_list_hash: null,
            common_login_methods_list: [],
            common_login_methods_list_hash: null,
            epop_accounts: [],
            contract_is_finished: false,
            customer_default_list: []
        }
    },
    computed: {
        fields_proxy() {
          return this.actual_account_fields.filter(i => {
            if (i.key === 'login_password' && this.params.login_type_id === 4) {
                return false
            }
            return i.show.includes(this.params.multi_payee)
          })
        },
        actual_account_fields() {
            return [
                {
                    label: '',
                    type: 'radio_buttons',
                    key: 'multi_payee',
                    row:true,
                    required: true,
                    rules: [commonValidateRuleGo],
                    show: [1, 2, 3],
                    items: [
                        {
                            value: 1,
                            key: 1,
                            label: '实际账号',
                        },
                        {
                            value: 2,
                            key: 2,
                            label: '虚拟账号',
                        },
                        {
                            value: 3,
                            key: 3,
                            label: '已有账号',
                        }
                    ],
                    change: (v) => this.changeMultiPayee(v)
                },
                {
                    show: [3],
                    label: '账号',
                    key:'id',
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'dis_text',
                    api: this.$util.api.epop_account_select_search,
                    initList: this.epop_accounts, // this.apply_user_list,
                    required: true,
                    rules: [commonValidateRuleGo],
                    handle_data:a => {
                        return a.map(i => ({
                            ...i,
                            dis_text: `${i.uid}-${i.account_name}`
                        })) 
                    },
                    change: (_, t) => {
                        this.params.uid = t.uid
                        this.params.account_name = t.account_name
                    }
                },
             
                {
                    label: '所属平台',
                    key:'platform_id',
                    // initList: this.defaultApply,
                    type:'autocompletes',
                    'item-value':'id',
                    'item-text':'name',
                    required: true,
                    items:this.platform_list,
                    rules: [commonValidateRuleGo],
                    show: [1, 2],
                    change: (v) => {
                        if (!this.platform_list_hash) {
                            const platform_list_hash = {}
                            this.platform_list.forEach(platform => {
                                platform_list_hash[platform.id] = platform
                            });
                            this.platform_list_hash = platform_list_hash
                        
                        }
                        this.params.platform_name = getsafe(this.platform_list_hash, `${v}.name`, '') 
                     
                    }
                },
                // ams_common_login_methods
                {
                    label: '用途',
                    key:'purpose',
                    rules: [commonValidateRuleT],
                    required: true,
                    show: [1],
                },
                {
                    label: '账号名称',
                    key: 'account_name',
                    rules: [commonValidateRuleT],
                    required: true,
                    show: [1],
                },
                {
                    label: '账号类型',
                    type: 'select_field_v1',
                    key: 'account_type',
                    clearable:true,
                    items: account_types,
                    rules: [commonValidateRuleT],
                    required: true,
                    show: [1, 2],
                },
                {
                    label: '登录方式',
                    key:'login_type_id',
                    type:'autocompletes',
                    'item-value':'id',
                    'item-text':'description',
                    rules: [commonValidateRuleGo],
                    required: true,
                    show: [1],
                    items:this.common_login_methods_list,
                    change: (v) => {
                        if (!this.common_login_methods_list_hash) {
                            const common_login_methods_list_hash = {}
                            this.common_login_methods_list.forEach(common_login_method => {
                                common_login_methods_list_hash[common_login_method.id] = common_login_method
                            });
                            this.common_login_methods_list_hash = common_login_methods_list_hash
                        
                        }
                        this.params.login_type_name = getsafe(this.common_login_methods_list_hash, `${v}.description`, '') 
                        if (v === 4) {
                            this.params.login_password = null
                        }
                    }
                },
                {
                    label: '登录账号',
                    key: 'login_username',
                    rules: [commonValidateRuleT],
                    required: true,
                    show: [1],
                },
                {
                    label: '登录密码',
                    key: 'login_password',
                    rules: [commonValidateRuleT],
                    required: true,
                    show: [1],
                },
                {
                    label: '支付密码',
                    key: 'payment_password',
                    show: [1],
                },
                {
                    label: '账户负责人',
                    key:'customer_id',
                    rules: [commonValidateRuleGo],
                    required: true,
                    out_params: {
                        formal: true,
                    },
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'account',
                    api: this.$util.api.customer_select_search,
                    initList:  this.customer_default_list, // this.apply_user_list,
                   // rules: [commonValidateRuleGo],
                    handle_data:({customers}) => {
                     return customers
                    },
              
                    show: [1, 2],
                },
                {
                    label: '备注',
                    type: 'textareas_field',
                    key: 'remark',
                    show: [1, 2],
                }
            ]
        }
    },
    created() {
        this.init()
    },
    methods: {
        submit() {
            if (this.$refs.base.validate()) {
                this.value.epop_account = this.params
                this.show = false
            }
        },
        changeMultiPayee(v) {
            const params = {
                multi_payee: v,
                ...createEpopAccount()
            }
            this.params = params
            switch (v) {
                case 1:
                    params.virtual = false
                    break
                case 3:
                    params.activity = true
                    params.virtual = false
                    break;
                case 2:
                    params.virtual = true
                    break;
                default:
                    break;
            }
         
        },
        initEpopAccount() {
            const virtual = getsafe(this.value, 'epop_account.virtual', false) 
            const contract_id = getsafe(this.value, 'id') 
            const activity = getsafe(this.value, 'epop_account.activity') 
           
            const epop_account = this.value.epop_account || {}
            const params = {
                ...createEpopAccount(),
                ...epop_account
            }
            params.virtual = virtual
            params.ams_account_id = null
            params.id = null
            this.contract_is_finished = false
            if (activity) { // 选择已有账号
                this.epop_accounts = [
                    {
                        id: epop_account.id,
                        uid: epop_account.uid,
                        account_name: epop_account.account_name,
                        dis_text: `${epop_account.uid}-${epop_account.account_name}`
                    }
                ]
                params.ams_account_id = epop_account.ams_account_id
                params.id = epop_account.id
                params.multi_payee = 3
             
            } else if (virtual) { // 虚拟账户
                params.multi_payee = 2
            } else { // 实际账号
                params.multi_payee = 1
            }
            
            this.params = params
            if (contract_id) {
                getContractDetailApi({id:contract_id}).then(res => {
                    this.contract_is_finished = getsafe(res, 'contract.user_flow.is_finish', false)
                })
            }
            if (epop_account.customer_id) {
                     getPersonApi({
                        id: epop_account.customer_id
                    }).then(res => {
                        if (res.customer) {
                            this.customer_default_list = [res.customer]
                        
                        }
                    })
            }
     
            // getContractDetailApi
        },  
        edit() {
            this.show = true
            this.initEpopAccount()
        },
        init() {
            if (!this.platform_list.length) {
                getAmsPlatformListApi().then(res => {
                  
                 this.platform_list = res
                })      
            }
            if (!this.common_login_methods_list.length) {
                getAmsCommonLoginMethodsApi().then(res => {
                    this.common_login_methods_list = res
                })
            }
          
          
        }
    },
    render() {
        return <VModal
        dynamicHeight
        heightRate={0.8}
        v-model={this.show}
        title="登记账号信息"
        loading={this.saving}
        width={600}
        okText="保存"
        on={{
            ok: this.submit,
        
        }}
        >
         <VForm ref="base"
                fields={this.fields_proxy}
                v-model={this.params}
            /> 
        </VModal>
    }
}